/* global jQuery COMPONENTS Plyr */

COMPONENTS.ComponentVideoCallout = (function ($) {
  function ComponentVideoCallout () {
    this.utility = new COMPONENTS.Utility()
    this.$component = $('[data-ecs-component="component-videocallout"]')
    this.$plyrElements = this.$component.find('[data-ecs-components-control="plyr"]')
    this.player = null
  }

  ComponentVideoCallout.prototype.init = function () {
    const component = this

    if (this.$plyrElements.length < 1) {
      // there is no player element on the page, bail so we don't crash the JS
      return
    } else if (this.$plyrElements.length >= 1) {
      // if there is more than one plyr element, init each one
      component.$plyrElements.each(function() {
        this.player = new Plyr($(this).get(0))
        this.autoplay = $(this).data('plyrAutoplay')

        // if autoplay is enabled on this Video Callout, wait for plyr, then play
        if (this.autoplay === 'autoplay_yes') {
          this.player.on('ready', () => {
            this.player.muted = true
            this.player.play()
          })
        }
      })
    }

    return
  }

  return ComponentVideoCallout
})(jQuery)

document.addEventListener('components_init', function (e) {
  // Hook into the main components init
  COMPONENTS.componentVideoCallout = new COMPONENTS.ComponentVideoCallout()
  COMPONENTS.componentVideoCallout.init()
})
